<template>
  <div class="course-main">
    <div class="title">{{ detail.title }}</div>
    <div class="cover">
      <img :src="detail.srcImgNew" alt="" class="cover-img" />
      <div class="cover-bottom">
        <div class="start-time">{{ formatDate(detail.startTime) }}开播</div>
        <div class="preView-num">{{ detail.preBookCount }}人预约</div>
      </div>
    </div>
    <div class="btn-box" :class="{ 'btn-plain': detail.preBookStatus === 1 }" @click="yyClick">
      <span class="btn">{{ detail.preBookStatus === 1 ? '预约成功' : '点击预约' }}</span>
      <img class="img" src="../../pages/share/images/click.gif" alt="" />
    </div>
    <div class="commit">预约成功后，直播开始我们会通知您</div>
  </div>
</template>
<script>
import service from '@/api/modules/payment/baijiayue'
import { appUser } from '@/utils'
import { Toast } from 'vant'

export default {
  components: {},
  props: ['detail'],
  data() {
    return {}
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {
    yyClick() {
      if (this.detail.preBookStatus === 1) return
      service
        .yyLive({
          roomId: this.detail.roomId,
          status: this.detail.preBookStatus === 1 ? -1 : 1,
          userId: appUser.userId
        })
        .then(() => {
          Toast('预约成功')
          this.$emit('getDetail')
        })
    },
    formatDate(dateStr) {
      // 将日期字符串解析为Date对象
      let date = new Date(dateStr)

      // 获取星期几的名称
      let weekdayName = ['周日', '周一', '周二', '周三', '周四', '周五', '周六']

      // 格式化日期字符串
      let year = date.getFullYear()
      let month = date.getMonth() + 1 // 月份从0开始计数，需要加1
      let day = date.getDate()
      let weekday = weekdayName[date.getDay()] // 获取星期几的名称
      let hours = date.getHours()
      let minutes = date.getMinutes()

      // 将月、日、小时、分钟都以两位数形式输出，不足两位前面补0
      month = month < 10 ? '0' + month : month
      day = day < 10 ? '0' + day : day
      hours = hours < 10 ? '0' + hours : hours
      minutes = minutes < 10 ? '0' + minutes : minutes

      // 将格式化后的日期字符串输出
      let formattedDate = `${month}-${day}(${weekday}) ${hours}:${minutes}`

      return formattedDate
    }
  }
}
</script>
<style lang="scss" scoped>
.course-main {
  .title {
    font-weight: 600;
    font-size: 22px;
    line-height: 31px;
    color: #333333;
    margin-bottom: 20px;
  }
  .cover {
    position: relative;
    overflow: hidden;
    border-radius: 8px;
    .play-icon {
      position: absolute;
      top: 50%;
      left: 50%;

      display: inline-block;
      width: 48px;
      height: 48px;
      margin-top: -24px;
      margin-left: -24px;
    }
    img {
      border-radius: 8px;
    }
    .cover-bottom {
      position: absolute;
      bottom: 3px;
      left: 0;
      right: 0;
      padding: 12px;
      display: flex;
      color: #fff;
      font-size: 12px;
      justify-content: space-between;
      border-radius: 0 0 8px 8px;
      background: linear-gradient(180deg, rgba(0, 0, 0, 0.25) 0%, rgba(0, 0, 0, 0.5) 100%);

      .start-time {
      }
      .preView-num {
      }
    }
  }
  img {
    max-width: 100%;
  }
  .cover-img {
    background: #ccc;
  }
  .play-num {
    position: absolute;
    bottom: 12px;
    right: 16px;
    display: flex;
    align-items: center;
    .play-vant-icon {
      color: #fff;
      width: 15px;
      height: 13px;
      border: solid 1px #fff;
      font-size: 12px;
      border-radius: 2px;
      margin-right: 12px;
    }
    .num {
      font-size: 12px;
      color: #fff;
    }
  }
  .difficulty {
    position: absolute;
    left: 0px;
    top: 0px;
    background: linear-gradient(95.41deg, #407879 0%, #00b25a 100%);
    border-radius: 8px 0 8px 0;
    color: #ffffff;
    font-size: 12px;
    padding: 4px 8px;
  }
  .teacher {
    position: absolute;
    left: 16px;
    bottom: 12px;
    display: flex;
    align-items: center;
    color: #fff;
    font-size: 14px;
    .teacher-img {
      display: inline-block;
      width: 24px;
      height: 24px;
      border-radius: 50%;
      margin-right: 12px;
      background: #fff;
    }
  }
  .course-name-translate {
    position: absolute;
    left: 16px;
    top: 36px;
    color: #fff;
    font-size: 18px;
    line-height: 24px;
    font-weight: 700;
  }
}
.btn-box {
  margin-top: 20px;
  position: relative;
  .btn {
    background: #00b25a;
    border-radius: 8px;
    padding: 17px;
    text-align: center;
    font-weight: 500;
    font-size: 16px;
    color: #ffffff;
    width: 100%;
    display: inline-block;
  }
  &.btn-plain {
    .btn {
      background: #fff;
      color: #00b25a;
      border: solid 1px #00b25a;
    }
    & {
      .img {
        display: none;
      }
    }
  }
  .img {
    position: absolute;
    display: inline-block;
    width: 104px;
    height: 104px;
    top: 0;
    right: 25px;
  }
  .img1 {
    width: 100%;
    // max-width: 750px;
  }
}
.commit {
  color: #999;
  margin-top: 60px;
  text-align: center;
}
</style>
